import $ from 'jquery';

export function sanitizeHtml(html: string | null)
{
    if (!html) return null;

    const output = $($.parseHTML('<div>' + html + '</div>', null, false));

    const whitelistTags = ['address', 'article', 'aside', 'footer', 'header', 'h1' , 'h2' , 'h3' , 'h4' , 'h5' , 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div', 'dl', 'dt', 'li', 'ol', 'p', 'pre', 'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'code', 'dfn', 'em', 'i', 'kbd', 'q', 's', 'small', 'span', 'strong', 'sub', 'sup', 'u', 'var', 'wbr', 'samp'];

    const unwrapTags = [{tag: 'cite'}, {tag: 'data'}, {tag: 'mark'}, {tag: 'time'}, {tag: 'a', wrap: true}];

    const whitelistAttributes = ['dir'];

    unwrapTags.forEach(tag => output.find(tag.tag).contents().unwrap().wrap(tag.wrap ? '<span></span>' : ''));

    output.find('*').each(function() {

        if (!whitelistTags.includes(this.tagName.toLowerCase()))
        {
            this.remove();
        }
        else
        {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const node = this;

            $.each(node.attributes, function()
            {
                if (this && !whitelistAttributes.includes(this.name.toLowerCase()))
                {
                    $(node).removeAttr(this.name);
                }
            });

            if (!whitelistAttributes.includes('style'))
            {
                $(node).removeAttr('style');
            }
        }
    });

    return output.html().replace(/<!--(.*?)-->/ig, '').trim();
}
